// @flow

import * as React from 'react';

import {BodyMono} from 'sail/Text';
import {CompactTooltip} from 'sail/Tooltip';

import {useStripeClui} from './helpers/react/provider';

import type {Param, Command} from './helpers/commands/resource';

// Takes in a list for suggestions and displays it.
const StripeCluiSuggestions = ({
  list,
  enterSuggestion,
}: {
  list: Array<[string, Command]> | Array<[string, Param]> | Array<[string, {}]>,
  enterSuggestion: (idx: number) => void,
}) => {
  const {
    state: {panes, focusedPane, isFocused},
  } = useStripeClui();

  const {suggestionIndex, allowInput, displayOn} = panes[focusedPane];

  const suggestionRef = React.useRef(null);

  React.useEffect(() => {
    if (displayOn === 'suggestion' && suggestionRef.current) {
      suggestionRef.current.scrollIntoView({block: 'nearest'});
    }
  }, [suggestionIndex, displayOn]);

  if (!allowInput || !isFocused || !list || !list.length) {
    return <></>;
  }

  return list.map<React.Node>((option, idx) => {
    let color = 'gray300';
    if (suggestionIndex >= 0 && idx === suggestionIndex) {
      color = 'white';
    }

    let outputOption = option[0];
    if (option[1] && option[1].required) {
      outputOption = `${option[0]} (required)`;
    }

    const suggestion = (
      <BodyMono color={color} wordBreak="all" key={idx}>
        {outputOption}
      </BodyMono>
    );

    return (
      <div
        onClick={() => {
          enterSuggestion(idx);
        }}
        idx={idx}
        key={idx}
        role="option"
        style={{
          cursor: 'pointer',
        }}
        ref={
          suggestionIndex >= 0 && idx === suggestionIndex ? suggestionRef : null
        }
      >
        {option[1] && option[1].description ? (
          <CompactTooltip
            variableWidth
            position="right"
            context={() => suggestion}
            label={String(option[1].description)}
          />
        ) : (
          suggestion
        )}
      </div>
    );
  });
};

export default StripeCluiSuggestions;
